'use strict';
const angular = require('angular');

export class PermissionEditComponent {
  /*@ngInject*/
  constructor() {
    this.permissions = {};
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.hasOwnProperty("data")) {
      this.permissions = angular.copy(this.config.data);

      this.readOwn = false;
      this.updateOwn = false;
      this.deleteOwn = false;

      this.customCreatePermissions = [];
      this.customReadPermissions = [];
      this.customUpdatePermissions = [];
      this.customDeletePermissions = [];

      this.entityTypes = ["community"];
      this.entities = {
        "community": ["DEMO","SUN"]
      };

      /* CREATE */
      if (!this.permissions.create.length) {
        this.createState = "None";
      } else if (this.permissions.create.indexOf("all") != -1) {
        this.createState = "All";
      } else {
        this.createState = "Custom";

        this.permissions.create.forEach(permission => {
          let parts = permission.split(":");
          if (parts.length == 2) { //then it is a custom permission <type>:<entity> e.g. community:DEMO
            this.customCreatePermissions.push({
              type: parts[0],
              entity: parts[1]
            })
          }
        })
      }

      /* READ */
      if (!this.permissions.read.length) {
        this.readState = "None";
      } else if (this.permissions.read.indexOf("all") != -1) {
        this.readState = "All";
      } else {
        this.readState = "Custom";
        this.readOwn = this.permissions.read.indexOf("own") != -1;

        this.permissions.read.forEach(permission => {
          let parts = permission.split(":");
          if (parts.length == 2) { //then it is a custom permission <type>:<entity> e.g. community:DEMO
            this.customReadPermissions.push({
              type: parts[0],
              entity: parts[1]
            })
          }
        })
      }

      /* UPDATE */
      if (!this.permissions.update.length) {
        this.updateState = "None";
      } else if (this.permissions.update.indexOf("all") != -1) {
        this.updateState = "All";
      } else {
        this.updateState = "Custom";
        this.editOwn = this.permissions.update.indexOf("own") != -1;

        this.permissions.update.forEach(permission => {
          let parts = permission.split(":");
          if (parts.length == 2) { //then it is a custom permission <type>:<entity> e.g. community:DEMO
            this.customUpdatePermissions.push({
              type: parts[0],
              entity: parts[1]
            })
          }
        })
      }

      /* DELETE */
      if (!this.permissions.delete.length) {
        this.deleteState = "None";
      } else if (this.permissions.delete.indexOf("all") != -1) {
        this.deleteState = "All";
      } else {
        this.deleteState = "Custom";
        this.deleteOwn = this.permissions.delete.indexOf("own") != -1;

        this.permissions.delete.forEach(permission => {
          let parts = permission.split(":");
          if (parts.length == 2) { //then it is a custom permission <type>:<entity> e.g. community:DEMO
            this.customDeletePermissions.push({
              type: parts[0],
              entity: parts[1]
            })
          }
        })
      }
    }
  };

  addCustom(section) {

    let custom = [];

    switch (section) {
      case "create":
        custom = this.customCreatePermissions;
        break;
      case "read":
        custom = this.customReadPermissions;
        break;
      case "update":
        custom = this.customUpdatePermissions;
        break;
      case "delete":
        custom = this.customDeletePermissions;
        break;
    }

    custom.push({type:'', entity:''});
    this.update(section);
  }

  removeCustom(section, idx) {
    let custom = [];
    switch (section) {
      case "create":
        custom = this.customCreatePermissions;
        break;
      case "read":
        custom = this.customReadPermissions;
        break;
      case "update":
        custom = this.customUpdatePermissions;
        break;
      case "delete":
        custom = this.customDeletePermissions;
        break;
    }

    custom.splice(idx, 1);
    this.update(section);
  }

  update(section) {

    let custom = "";
    let state = "";

    switch (section) {
      case "create":
        custom = this.customCreatePermissions;
        state = this.createState;
        break;
      case "read":
        custom = this.customReadPermissions;
        state = this.readState;
        break;
      case "update":
        custom = this.customUpdatePermissions;
        state = this.updateState;
        break;
      case "delete":
        custom = this.customDeletePermissions;
        state = this.deleteState;
        break;
    }

    switch (state) {
      case 'None':
        this.permissions[section] = [];
        break;
      case 'All':
        this.permissions[section] = ["all"];
        break;
      case 'Custom':
        this.permissions[section] = [];

        custom.forEach(perm => {
          if (perm.type && perm.entity) {
            this.permissions[section].push(perm.type + ":" + perm.entity);
          }
        });
        
        if (this[section+"Own"]) this.permissions[section].push("own");
        break;
    }
    
  }

  ok() {
    this.close({$value: this.permissions});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.permissionEdit', [])
  .component('permissionEdit', {
    template: require('./permission-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: PermissionEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/permission-edit/permission-edit.component.js